import React from "react";
import { Balance } from "../models/balance";
import { FormattedMessage } from "react-intl";

interface BalanceItemProps {
    balanceItem: Balance;
}

export enum Unit {
    Time = 1,
    Pieces = 2,
    Money = 3
}

export function convertBalance(balance: number, balanceUnit: Unit): string {
    let isNegative = false;
    if (balance < 0) {
        balance = Math.abs(balance);
        isNegative = true;
    }
    if (balanceUnit == Unit.Time) {
        let seconds = balance;
        const hours = Math.floor(seconds / 3600);
        seconds = seconds % 3600;
        const minutes = Math.floor(seconds / 60);
        let hoursToString = hours.toString();
        let minutesToString = minutes.toString();
        if (hours < 10) { hoursToString = "0" + hours; }
        if (minutes < 10) { minutesToString = "0" + minutes; }

        const hourMinuteString = `${hoursToString}:${minutesToString}`;
        return isNegative ? `-${hourMinuteString}` : hourMinuteString;
    }
    else {
        return isNegative ? "-" + balance.toString() : balance.toString();
    }
}

const BalanceItem: React.SFC<BalanceItemProps> = props => {
    return (
        <div className="balanceItem-div" key={props.balanceItem.terminalBalanceName}>
            <span>
                <p className="balanceItem-terminalname">{props.balanceItem.terminalBalanceName}</p>
                <p className="balanceItem-balance">{convertBalance(props.balanceItem.balance, props.balanceItem.balanceUnit)}</p>
                <FormattedMessage id={"Timeperiod." + props.balanceItem.timePeriodName} />
            </span>
        </div>
    );
};
export default BalanceItem;